/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconMushroom = createSolidComponent("mushroom", "IconMushroom", [
  [
    "path",
    {
      d: "M20 11.1c0 -4.474 -3.582 -8.1 -8 -8.1s-8 3.626 -8 8.1a.9 .9 0 0 0 .9 .9h14.2a.9 .9 0 0 0 .9 -.9z"
    }
  ],
  ["path", { d: "M10 12v7a2 2 0 1 0 4 0v-7" }]
]);

export { IconMushroom as default };
//# sourceMappingURL=IconMushroom.js.map
